// The contact-support affordance embedded in error surfaces.
import type { CSSProperties, ReactNode } from 'react';
import { SUPPORT_EMAIL, buildSupportContext, supportMailto, type SupportContext } from '@/lib/support';

export interface SupportLinkProps {
  subject: string;
  context?: SupportContext;
  variant?: 'inline' | 'block';
  children?: ReactNode;
}

const INLINE_STYLE: CSSProperties = {
  fontSize: 12,
  color: 'var(--v-ink, var(--zk-text))',
};

const BLOCK_STYLE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 12,
  color: 'var(--v-ink-1, #1B1D22)',
  textDecoration: 'none',
  borderBottom: '1px solid currentColor',
  paddingBottom: 2,
};

export function SupportLink({ subject, context, variant = 'inline', children }: SupportLinkProps) {
  return (
    <a
      data-support-link
      href={supportMailto(subject, buildSupportContext(context))}
      style={variant === 'block' ? BLOCK_STYLE : INLINE_STYLE}
    >
      {children ?? `Contact support (${SUPPORT_EMAIL})`}
    </a>
  );
}
